import { useState, useEffect, useMemo } from "react";
import { t } from "@/lib/i18n";
import api from "@/lib/api";

export const useMailboxApi = () => {
  const [mailbox, setMailbox] = useState(() => new URLSearchParams(window.location.search).get("mailbox") || "");
  const mbApi = useMemo(() => {
    const inject = (cfg = {}) => ({ ...cfg, params: { ...(cfg.params || {}), ...(mailbox ? { mailbox } : {}) } });
    return {
      get: (u, c) => api.get(u, inject(c)),
      post: (u, d, c) => api.post(u, d, inject(c)),
      put: (u, d, c) => api.put(u, d, inject(c)),
      patch: (u, d, c) => api.patch(u, d, inject(c)),
      delete: (u, c) => api.delete(u, inject(c)),
    };
  }, [mailbox]);
  return { mailbox, setMailbox, mbApi };
};

export const MailboxSwitcher = ({ mailbox, onChange }) => {
  const [shared, setShared] = useState([]);
  useEffect(() => {
    api.get("/shared-inboxes").then((r) => setShared((r.data.shared_inboxes || []).filter((s) => s.active))).catch(() => {});
  }, []);
  if (shared.length === 0) return null;
  const pill = (active) =>
    `px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${active ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`;
  return (
    <div data-testid="mailbox-switcher" className="flex items-center gap-2 flex-wrap mb-4">
      <span className="text-xs text-gray-400">{t("si.viewing", "Viewing:")}</span>
      <button data-testid="mb-pill-personal" className={pill(!mailbox)} onClick={() => onChange("")}>
        {t("si.my_inbox", "My inbox")}
      </button>
      {shared.map((s) => (
        <button key={s.id} data-testid={`mb-pill-${s.id}`} className={pill(mailbox === s.id)} onClick={() => onChange(s.id)}>
          <span className="inline-block w-2 h-2 rounded-full mr-1.5" style={{ background: s.color || "#2563eb" }} />
          {s.name}
        </button>
      ))}
    </div>
  );
};
